import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipToggle,
} from '@mc/design-system'
import { Trans } from '@mc/i18n'

export interface NextButtonProps {
  disabled: boolean
  disabledText: string
  onNext: () => void
}

export const NextButton = ({
  disabled,
  disabledText,
  onNext,
}: NextButtonProps) => (
  <TooltipDisclaimerWrapper disabled={disabled} text={disabledText}>
    <Button
      disabled={disabled}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault()
          return
        }
        onNext()
      }}
      fullWidth
      kind='primary'
      size='md'
    >
      <Trans i18nKey={'findMyClasses.common.cta'} ns='@mc/next' />
    </Button>
  </TooltipDisclaimerWrapper>
)

const TooltipDisclaimerWrapper = ({
  children,
  disabled,
  text,
}: {
  disabled: NextButtonProps['disabled']
  text: NextButtonProps['disabledText']
  children: React.ReactElement | React.ReactElement[]
}) => (
  <Tooltip>
    <TooltipToggle>{children}</TooltipToggle>
    {disabled && (
      <TooltipContent id='next-disabled-disclaimer'>{text}</TooltipContent>
    )}
  </Tooltip>
)
